<template>
  <div class="label-wrap">
    <div
      class="label"
      :style="{'background-color': backgroundColor}"
      @click="changeBackgroundColor($event)"
    ></div>
    
    <Tooltip position="tr">
      <div class="&__label">{{ labelName }}</div>
    </Tooltip>
  </div>
  
</template>

<script>
  import Tooltip from "@/components/atoms/Tooltip.vue";

  export default {
      name: "Label",
      data() {
        return {
          colors: [
            { name: 'Default', value: '#6A6A6A' },
            { name: 'Important', value: '#FF8A00' },
            { name: 'Label 1', value: '#6BC754' },
            { name: 'Label 2', value: '#B86FE4' },
        ],
        currentColorIndex: 0,
        }
      },
      components: {
        Tooltip
      },
      computed: {
        backgroundColor() {
            return this.colors[this.currentColorIndex].value;
        },
        labelName() {
            return this.colors[this.currentColorIndex].name;
        },
      },
      methods: {
        changeBackgroundColor(event) {
            event.stopPropagation();
            this.currentColorIndex = (this.currentColorIndex + 1) % this.colors.length;
        },
      },
  };
</script>

<style scoped lang="scss">
.label-wrap {
  position: absolute;
  top: -7px;
  left: -5px;
  height: 9px;
  //z-index: 10;
  &:hover {
    .tooltip-container {
      display: block;
    }
  }
  .tooltip-container {
    display: none;
  }

}
.label {
  width: 15px;
  height: 100%;
  border-radius: 6px 0px;
  position: relative;
  &.usual {
    background: #6A6A6A;
  }
  &.important {
    background: $orange;
  }
  /* need to change name */
  &.green {
    background: $green;
  }
  &.purple {
    background: $purple;
  }
}
</style>